<template>
<div>
    <span class="cs-studentList-Phone" @click="showStudentProfile()">{{ this.studentPhone}}</span>
</div>
</template>

<style lang="scss" scoped>
.cs-studentList-Phone {
    color: #409EFF;
    cursor: pointer;
}
</style>

<script>
import {
    saveCommentsChange
} from "../../../service/finance.service.js";
export default {
    props: {
        data: {},
        columnData: {},
        status: {},
        editLocation: {}
    },
    data() {
        return {
            studentPhone: "",
            studentId: 0
        };
    },
    components: {},
    created() {
        this.init();
    },
    methods: {
        init() {
            this.studentPhone = this.data.Phone;
            this.studentId = this.data.StudentId;
        },
        showStudentProfile() {
            this.$router.push({
                path: "/studentProfile",
                query: {
                    studentId: this.studentId
                }
            });
        }
    },
    watch: {
        editLocation: function () {},
        data: function () {
            this.init();
        },
        status: function () {}
    }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/studentPhoneCell.vue